// extracted by mini-css-extract-plugin
export var falconContainer = "_vk-2";
export var offerCenter = "_vk-0";
export var roktContainer = "_vk-1";